/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	EmailTemplatesUpdatePathParams,
	EmailTemplatesUpdateRequest,
	EmailTemplatesUpdateResponse,
} from '../types/EmailTemplatesUpdate'

/**
 * PUT /email-templates/:emailTemplate
 * @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::update
 */
export async function emailTemplatesUpdate(
	emailTemplate: EmailTemplatesUpdatePathParams['emailTemplate'],
	data: EmailTemplatesUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<EmailTemplatesUpdateResponse>> {
	return axiosInstance.put(`/email-templates/${emailTemplate}`, data, config)
}
